// src/utils/s3.js
import { postJson, uploadFileToPresignedUrl } from "./api";
import financeApi from "api/finance-api";

// PUT strategy by default (simple fetch upload)
export async function presignAndUpload(file) {
  const { data } = await financeApi.uploads.presign({
    filename: file.name,
    content_type: file.type,
  });

  // POST style
  if (data?.strategy === "post") {
    const form = new FormData();
    Object.entries(data.fields || {}).forEach(([k, v]) => form.append(k, v));
    form.append("file", file);
    const resp = await fetch(data.url, { method: "POST", body: form });
    if (!resp.ok) throw new Error("S3 upload failed");

    return { key: data.fields.key, url: `${data.public_base}/${data.fields.key}` };
  }

  // PUT style
  const put = await fetch(data.url, { method: "PUT", headers: { "Content-Type": file.type }, body: file });
  if (!put.ok) throw new Error("S3 upload failed");
  return { key: data.key, url: data.public_url };
}

/** New: use finance v2 PUT-presign */
export async function presignAndUploadFinance(file) {
  const { name, type } = file;
  const { data } = await financeApi.uploads.presign({ filename: name, content_type: type || "application/octet-stream" });
  const { upload_url, public_url } = data || {};
  if (!upload_url || !public_url) throw new Error("Bad presign response");

  const resp = await fetch(upload_url, { method: "PUT", headers: { "Content-Type": type || "application/octet-stream" }, body: file });
  if (!resp.ok) throw new Error(`Upload failed (${resp.status})`);
  return public_url;
}
